import PropTypes from 'prop-types'
import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} dealerAccessLogEntryPropType
 * @property {string}           [dealerName]        - The name of the dealer
 * @property {string}           [dealerUserName]    - The username of the dealer
 * @property {iso8601PropType}  [loginTime]         - The timestamp when the dealer logged into the customer account
 * @property {string}           [reason]            - The reason why the dealer logged into the customer account
 */
export const dealerAccessLogEntryPropType = PropTypes.shape({
    dealerName: PropTypes.string,
    dealerUserName: PropTypes.string,
    loginTime: iso8601PropType,
    reason: PropTypes.string
})
